/*
Sohel  09/22/2022  2699250881  Custom Windows Feedback Modifications
Sohel  09/23/2022  2699250881  Fixed Custom Windows Feedback Changes
Sohel  09/26/2022  2699250881  Added Window Owner Field, columns to dashboard table,bugfixes.
Aditya 09/29/2022  2699250881  Referrence textfield, Global field payload modification
Ashraf 09/30/2022  2699250881  fixed global payload issues
Sohel  09/30/2022  2699250881  Fixed Page break issue.
Sohel  09/30/2022  2699250881  resolved merge conflict
Sohel  10/03/2022  2699250881  Fixed GAL-348 and Custom Windows Catagory added Look UP API.
Ashraf 10/15/2022  2699250881  Added custom windows code comments
Suresh Peddavoora 10/28/2022 2699250881 Added Rows per screen text in table pagination
Ashraf 10/30/2022 2699250881 removed toolbar for table
saikrishna 11/03/2022 2699250881 Changed pagination options
*/
import React, {createRef, useEffect, useState} from 'react';
// import MaterialTable from "material-table";
import {Grid, TablePagination} from '@material-ui/core';
import {tableIcons} from '../../../../components/TableIcons';
import {httpPaginationPost} from '../../../../util/Rest';
import {useDispatch} from 'react-redux';
import {defaultRows} from '../../../../constants/ReusableTablePagination';
import GuiTable from '../../../FormComponents/GuiTable';
import {tablePageRows} from '../../../../constants/ReusableConstants';

// global fields table (2700768219)
export default function SearchDatabaseReferenceTable({
  searchData,
  setDataBaseValue,
  handleClose,
  submit,
  setSubmit,
}) {
  const columns = [
    {
      title: 'Category',
      field: 'category',
    },
    {
      title: 'Global Field Code',
      field: 'globalField',
    },
    {
      title: 'Global Field Description',
      field: 'description',
    },
    {
      title: 'Group Code',
      field: 'groupCode',
    },
    {
      title: 'Group Description',
      field: 'groupDescription',
    },
    {
      title: 'Table Name',
      field: 'tableName',
    },
    {
      title: 'Table Field Name',
      field: 'tableField',
    },
  ];
  const tableRef = createRef();
  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);

  // recall table api after search (2700768219)
  useEffect(() => {
    if (tableRef?.current && submit) {
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [submit, searchData]);

  return (
    <>
      <Grid item xs={12} className="">
        <div className="custom-table global-field-table">
          <GuiTable
            title={''}
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `globalfield/search/all`;
                const bodyObj = {
                  globalField: searchData?.globalField ? searchData.globalField : '',
                  category: searchData?.category?.categoryCode ? searchData?.category?.categoryCode : '',
                  tableName: searchData?.tableName ? searchData.tableName : '',
                  tableField: searchData?.tableFieldName ? searchData.tableFieldName : '',
                  description: searchData?.description ? searchData.description : '',
                  groupCode: searchData?.groupCode ? searchData.groupCode : '',
                  groupDescription: searchData?.groupDescription ? searchData.groupDescription : '',
                  limit: query.pageSize ? query.pageSize : null,
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                  orderDirection: query?.orderDirection ? query?.orderDirection : '',
                  search: query?.search ? query?.search : '',
                  page: submit ?
                    1 :
                    arrayLast && query.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                };
                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        resolve({
                          data: response.data.response.resultObject ?
                            response.data.response.resultObject :
                            [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setArrayLast(response.data.response.resultObject.length === 1);
                        setSubmit(false);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              search: false,
              pageSize: rows,
              toolbar: false,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            components={{
              Pagination: (props) => (
                <TablePagination
                  {...props}
                  SelectProps={{
                    inputProps: {'aria-label': 'Rows per screen'},
                  }}
                  labelRowsPerPage={'Rows per screen:'}
                  rowsPerPageOptions={tablePageRows}
                  onChangeRowsPerPage={(event) => {
                    props.onChangeRowsPerPage(event);
                    setRows(event.target.value);
                  }}
                />
              ),
            }}
            onRowClick={(event, rowData) => {
              setDataBaseValue(rowData?.globalField);
              handleClose();
            }}
          />
        </div>
      </Grid>
    </>
  );
}
